import { render, staticRenderFns } from "./CategorySelectListItem.vue?vue&type=template&id=4f8cbebc&scoped=true&"
import script from "./CategorySelectListItem.vue?vue&type=script&lang=js&"
export * from "./CategorySelectListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelectListItem.vue?vue&type=style&index=0&id=4f8cbebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cbebc",
  null
  
)

export default component.exports